import { combineReducers } from 'redux';

import deliveryReducer from '@/domains/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';
import brandReducer from '@/domains/productDiscovery/ProductPage/modules/Brand/brand.ducks';
import sponsoredDataReducer from '@/domains/productDiscovery/ProductPage/modules/SponsoredData/sponsoredData.reducer';
import trackingReducer from '@/domains/productDiscovery/ProductPage/tracking.reducer';

import quantityReducer from './common/modules/QuantitySelector/Quantity.ducks';
import detailReducer from './detail.reducer';

export default combineReducers({
  brand: brandReducer,
  delivery: deliveryReducer,
  detail: detailReducer,
  quantity: quantityReducer,
  sponsoredData: sponsoredDataReducer,
  tracking: trackingReducer,
});
